interface Props {
  content: string;
  /** When true: strips HTML and returns plain text (for line-clamped previews in cards) */
  preview?: boolean;
  className?: string;
  maxHeight?: string;
}

function stripHtml(html: string) {
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function RichTextDisplay({ content, preview = false, className = '', maxHeight }: Props) {
  if (!content) return null;

  if (preview) {
    return (
      <p className={`text-sm text-foreground/80 mt-2 line-clamp-2 break-words ${className}`}>
        {stripHtml(content)}
      </p>
    );
  }

  return (
    <div
      className={`rte text-sm text-foreground ${maxHeight ? 'overflow-y-auto' : ''} overflow-x-hidden ${className}`}
      style={{ ...(maxHeight ? { maxHeight } : {}), overflowWrap: 'anywhere' }}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
